var include_biz_news = `
<div class="title-h2 title-h2--under-h1">
	<h2>ニュースリリース</h2>
</div>
<div class="contents-wrap mt60">
	<div class="information">
		<ul class="information__list">
			<li class="information__list-item">
				<a href="/material/pdf/release/pdf/2024/20240508.pdf" class="information__link Nanaco_TopNews" target="_blank">
					<div class="information__inner">
						<p class="information__date">2024年5月8日</p>
						<div class="information__tag information__tag--news">ニュースリリース</div>
					</div>
					<p class="information__lead"><span class="information__lead-pdf">宝くじ売り場&emsp;「nanacoポイント2倍キャンペーン」のご案内</span></p>
				</a>
							</li>
			<li class="information__list-item">
				<a href="/material/pdf/release/pdf/2024/20240315.pdf" class="information__link Nanaco_TopNews" target="_blank">
					<div class="information__inner">
						<p class="information__date">2024年3月15日</p>
						<div class="information__tag information__tag--news">ニュースリリース</div>
					</div>
					<p class="information__lead"><span class="information__lead-pdf">Apple Payのnanacoアプリが600万ダウンロード突破!デビューキャンペーンを実施</span></p>
									</a>
							</li>
			<li class="information__list-item">
				<a href="/material/pdf/release/pdf/2023/20231117.pdf" class="information__link Nanaco_TopNews" target="_blank">
					<div class="information__inner">
						<p class="information__date">2023年11月17日</p>
						<div class="information__tag information__tag--news">ニュースリリース</div>
					</div>
					<p class="information__lead"><span class="information__lead-pdf">「nanaco アプリ(Android)」リニューアルのお知らせ</span></p>
									</a>
							</li>
			<li class="information__list-item">
				<a href="/material/pdf/release/pdf/2023/20231016.pdf" class="information__link" target="_blank">
					<div class="information__inner">
						<p class="information__date">2023年10月16日</p>
						<div class="information__tag information__tag--news">ニュースリリース</div>
					</div>
					<p class="information__lead"><span class="information__lead-pdf">nanacoの自治体マイナポイント事業参画について</span></p>
				</a>
			</li>
			<li class="information__list-item">
				<a href="/material/pdf/release/pdf/2023/20230703.pdf" class="information__link" target="_blank">
					<div class="information__inner">
						<p class="information__date">2023年7月3日</p>
						<div class="information__tag information__tag--news">ニュースリリース</div>
					</div>
					<p class="information__lead"><span class="information__lead-pdf">セブン銀行×セブン・カードサービス合同キャンペーンを実施</span></p>
				</a>
			</li>
		</ul>
	</div>
</div>
`;
